import { TStringField } from '../../../types/sitecore.types';
import { TMediaGalleryMosaicParams, TMediaGalleryMosaicProps, TMediaMosaicFields } from '../types/mosaicMediaGallery.types';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { TGalleryItem } from '../../../types/media.types';
import { getThumbnailProps } from '../../../utils/youtube.utils';
import { getImageField } from '../../../utils/getImageFields';
import { THeadingTag } from '../../../types/types';

// Cards Sizes With Transformations
const xs = { mobile: 'Size200', desktop: 'Size1000' };
const sm = { mobile: 'Size200', desktop: 'Size1000' };
const md = { mobile: 'Size300', desktop: 'Size1000' };
const lg = { mobile: 'Size500', desktop: 'Size1500' };

//Layout - Transformation map
const transformationMaps = {
  'layout-1': [lg],
  'layout-2': [sm, sm],
  'layout-3': [xs, xs, md],
  'layout-4': [xs, xs, md, lg],
  'layout-5': [xs, xs, md, sm, sm],
  'layout-6': [xs, xs, md, xs, xs, xs],
  'layout-7': [xs, xs, md, lg, xs, xs, xs],
  'layout-8': [xs, xs, md, sm, sm, lg, sm, sm],
  'layout-9': [xs, xs, md, lg, xs, xs, xs, sm, sm],
  'layout-10': [xs, xs, md, lg, sm, sm, sm, md, xs, xs],
  'layout-11': [xs, xs, md, lg, xs, xs, xs, lg, md, xs, xs],
  'layout-12': [xs, xs, md, lg, xs, xs, xs, sm, sm, md, xs, xs],
};

export class MosaicMediaGalleryModel {
  private readonly fields?;
  private readonly rendering?: ComponentRendering;
  private readonly params?: TMediaGalleryMosaicParams;

  constructor(_props: TMediaGalleryMosaicProps) {
    this.fields = _props?.fields || null;
    this.rendering = _props?.rendering;
    this.params = _props?.params;
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get eyebrow(): TStringField {
    return this.fields?.eyebrow;
  }

  get title(): TStringField {
    return this.fields?.title;
  }

  get description(): TStringField {
    return this.fields?.description;
  }

  get items(): Array<TGalleryItem> {
    if (this.fields?.items?.length > 0) {
      return this.fields?.items?.slice(0, 12)?.map((item: TMediaMosaicFields, index: number, galleryItems: Array<TMediaMosaicFields>) => {
        const { thumbnailImgSrc } = getThumbnailProps(item.fields?.video?.value?.href || '');
        const transformationMap = transformationMaps[`layout-${galleryItems.length}`];

        return {
          id: item.id,
          title: item.fields?.videoHeading,
          description: item.fields?.videoSubheading,
          editorialImageProps: {
            id: item.id,
            desktopImage: getImageField(item.fields?.image, thumbnailImgSrc || '', item.fields?.useVideo?.value),
            mobileImage: getImageField(item.fields?.mobileImage, thumbnailImgSrc || '', item.fields?.useVideo?.value),
            desktopTransformation: transformationMap[index]?.desktop,
            mobileTransformation: transformationMap[index]?.mobile,
            alt: item.fields?.image?.value?.alt,
          },
          isVideo: item.fields?.useVideo?.value,
          videoUrl: item.fields?.video?.value?.href,
        } as TGalleryItem;
      });
    }
    return [];
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h2';
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
